


























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Autocomplete from '@/components/AutocompleteAddress.vue';

import MapModule from '@/store/MapModule';

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import FiltersModule from '@/store/FiltersModule';
import AuthModule from '@/store/AuthModule';
import SideBarBlock from '@/components/prescriber/SideBarBlock.vue';
import moment from 'moment';
import taxSystems from '@/data/taxSystems';
import { typesArr, types2Arr, types ,  exposures, exposuresArr} from '@/data/types';
import chunk from 'lodash/chunk';
import regions from '@/data/regions';
import departments from '@/data/departments';
import { BACKEND_URL } from '@/helpers/constants';
import cities, { City } from '@/data/cities';
import {
    fetchProgramsPrescriber,
    fetchPromotorsPrescriber,
    fetchProgramOperatorPrescriber,
} from '@/utils/filters';
import FilterComponent from '@/components/FilterComponent.vue';
import debounce from 'lodash/debounce';
import take from 'lodash/take';
import { programStatus } from '@/data/programStatus';
import concat from 'lodash/concat';
import firebase from 'firebase';
import Auth = firebase.auth.Auth;
import ListModule from '@/store/ListModule';
import Lot from '@/models/Lot';
import Program from '@/models/Program';
import Address from '@/components/Address.vue';
import { forEach } from 'lodash';
import BRSModal from '@/components/prescriber/BRSModal.vue';
import BRSPopup from '@/components/prescriber/BRSPopup.vue';
import LLIModal from '@/components/prescriber/LLIModal.vue';


interface Ville {
    code: string;
    codeDepartement: string;
    codeRegion: string;
    codesPostaux: string[];
    nom: string;
    population: number;
}

const outdoors = {
    terrace: 'Terrasse',
    garden: 'Jardin',
    parking: 'Parking',
};

const outdoorsArr = Object.keys(outdoors).map((key) => ({
    text: (outdoors as any)[key],
    value: key,
}));

@Component({
    components: {
        Address,
        SideBarBlock,
        FilterComponent,
        Autocomplete,
        BRSModal,
        BRSPopup,
        LLIModal
    },
})
export default class SideBarPrescriber extends Vue {
    @Prop() displayHead: boolean = false;
    @Prop({ default: true, type: Boolean }) displayPrivate!: boolean;
    @Watch('auth', { deep: true })
    onAuth() {
        AuthModule.getUser();
    }

    programSold = {
        popup: false,
        program: '',
    };

    zones: any = {
        Abis: 'A bis',
        A: 'A',
        B1: 'B1',
        B2: 'B2',
        C: 'C',
    };
    filters: any = FiltersModule.filters;

    livrablePopup: boolean = false;
    actablePopup: boolean = false;
    programSearchType: string = 'name';
    showProgramSearchOptions: boolean = false;
    orientationPopup: boolean = false;

    isPrivateMode: boolean = false;

    handleExclusiveCheckbox(selected: string) {
  // Only enforce exclusivity when the selected checkbox is checked
  if (this.filters[selected]) {
    const checkboxes = ['includeDeliveryTrimester', 'isLivrable', 'isActable'];
    checkboxes.forEach(item => {
      if (item !== selected) {
        this.filters[item] = false;
      }
    });
  }
}

toggleProgramSearchType() {
    this.showProgramSearchOptions = !this.showProgramSearchOptions;
}

setProgramSearchType(type: string) {
    this.programSearchType = type;
    this.showProgramSearchOptions = false; // Fermer après sélection
    // @ts-ignore
    this.$refs.program.clear();
    this.filters.program = null;
}


async fetchProgramsByIdPrescriber(value: string) {
    if (!value || value.length < 1) {
        return [];
    }
    
    // Vérifier que c'est un nombre
    if (!/^\d+$/.test(value)) {
        return [];
    }

    // Utiliser fetchProgramsPrescriber avec un meta spécial pour l'ID
    const meta = {
        filters: {
            statusProgram: AuthModule.roles.includes("ROLE_MANAGER")
                ? ["to_control", "data_processing", "diffused"]
                : ['diffused', 'sold'],
            programId: parseInt(value) // Ajouter l'ID ici pour le backend
        }
    };

    try {
        // Utiliser fetchProgramsPrescriber au lieu de getProgramsPrescriber
        const results = await fetchProgramsPrescriber(value, meta);
        
        // Filtrer les résultats pour ne garder que ceux avec l'ID exact
        return results.filter((item: any) => 
            item.value && item.value.id && item.value.id.toString() === value
        );
    } catch (error) {
        console.error('Erreur lors de la recherche par ID:', error);
        return [];
    }
}


            toggleSidebar() {
                // Emit event to parent component to handle sidebar visibility
                this.$emit('toggle-sidebar');
                
                // Or if you're managing state locally:
                // this.sidebarVisible = !this.sidebarVisible;
            }

get programPlaceholder() {
    if (this.filters.program) {
        return '';
    }
    return this.programSearchType === 'name' 
        ? 'Tapez au moins 3 lettres' 
        : 'Tapez l\'ID du programme';
}

    // Methods to open modals
    openLivrablePopup() {
        this.livrablePopup = true;
    }

    openActablePopup() {
        this.actablePopup = true;
    }


    openOrientationPopup() {
        this.orientationPopup = true;
    }

    handleCheckboxChange(selected: string) {
        this.handleExclusiveCheckbox(selected);
        this.debugFilter();
    }

    @Watch('filters', { deep: true })
    onFilters() {
        
        
        console.log("Filters changed:", FiltersModule.filters);
        FiltersModule.onFilters(this.filters);

        if(this.filters.taxes.length && !this.isPinel()){
            this.displayFinBail = true;
        }else{
            this.displayFinBail = false;
        }
    }

    validateProfitabilityInput() {
    // Si la valeur est nulle ou vide, ne rien faire
    if (this.filters.profitabilityMin === null || this.filters.profitabilityMin === '') {
        return;
    }
    
    // Convertir en nombre
    let value = parseFloat(this.filters.profitabilityMin);
    
    // Si ce n'est pas un nombre valide, réinitialiser à 0
    if (isNaN(value)) {
        this.filters.profitabilityMin = 0;
        return;
    }
    
    // Limiter la valeur à 30 maximum
    if (value > 30) {
        console.log("Profitability value exceeds maximum (30), capping at 30");
        this.filters.profitabilityMin = 30;
    }
    
    // S'assurer que la valeur est arrondie à 1 décimale pour l'affichage
    this.filters.profitabilityMin = parseFloat(value.toFixed(1));
}

    incrementProfitability(amount: number) {
    if (!this.filters.profitabilityMin) {
        this.filters.profitabilityMin = 0;
    }
    const newValue = parseFloat(this.filters.profitabilityMin) + amount;
    
    // Cap the value at 30 maximum
    const cappedValue = Math.min(30, Math.max(0, newValue));
    this.filters.profitabilityMin = parseFloat(cappedValue.toFixed(1));
}

    // Vérification pour afficher l'alerte si la valeur dépasse 30%
    get dangerProfitability() {
        return parseFloat(this.filters.profitabilityMin) > 30;
    }

    @Watch('filters.usufruitDuration')
onUsufruitDurationChange() {
    if (this.filters.includeUsufruitDuration) {
        this.filters.dureeUsufruitInterval = [
            this.filters.usufruitDuration[0],
            this.filters.usufruitDuration[1]
        ]; 
    } else {
        this.filters.dureeUsufruitInterval = [null, null];
    }
    FiltersModule.onFilters(this.filters);
}



    usufruitFormatter(value: number) {
    return value + ' ans';
    }
    nueProFormatter(value: number) {
    return value + '%';
    }
    bailDurationFormatter(value: number) {
    return value + ' ans';
}


@Watch('filters.profitabilityMin')
onProfitabilityChange(newVal: number | null | undefined) {
    // Effectuer la validation à chaque changement de valeur
    this.validateProfitabilityInput();
}





                @Watch('filters.country')
                async onCountryChange(newCountry: string, oldCountry: string) {
        
                    if (newCountry && newCountry !== oldCountry) {
                        await MapModule.centerOnCountry(newCountry);
                        }
                    }
                
            


    interval = [40, 40 + 16];
    @Watch('interval')
    onInterval() {
        this.filters.dateInterval = [];
        
        this.interval.forEach((item) => {
            const currentQuarter = moment().quarter();
            const quarterValue = item / this.filters.timeStep;
            const quarter = currentQuarter + quarterValue;

            const date = moment()
                .quarter(quarter)
                .startOf('quarter')
                .toISOString();

            this.filters.dateInterval.push(date);
        });
    }

    time: any = null;
    scrollTop: number = 0;
    min: string = '';
    pinelPlusPopup: boolean = false;
    brsPopup: boolean = false;
    lliPopup: boolean = false;
    showUsufruitControls: boolean = false;
    showNueProControls: boolean = false;
    showReventeControls: boolean = false;
    max: string = '';
    region: string | null = null;
    departement: string | null = null;
    ville: string | null = null;
    program: string | null = null;
    taxSystemFamily = {
        VEFA: 'Régime général VEFA',
        LMNPVEFA: 'LMNP avec Bail Co. VEFA',
        ANCIEN: 'Ancien à Réhab.',
        LMNPREV: 'Immo Ancien',
        LOCALPRO: 'Local Pro',
    };
    //checkboxes
    VEFA: boolean = false;
    LMNPVEFA: boolean = false;
    ANCIEN: boolean = false;
    LMNPREV: boolean = false;
    displayFinBail: boolean = false;
    rechercher: boolean = false;

    familiesSelected: any = [];


    types2 = types2Arr.reduce((accu: any, item) => {
        accu[item.value] = false;
        return accu;
    });
    outdoors = outdoorsArr.reduce((accu: any, item) => {
        accu[item.value] = false;
        return accu;
    });
    cities: City[] = [];

    get show() {
        return FiltersModule.show;
    }

    toggle() {
        FiltersModule.toggleShow();
    }

    rechercheFilter() {}

    isPinel() {
        return (
            this.filters.taxes.includes('Pinel / Rés. principale') ||
            this.filters.taxes.includes('RP Tva Réduite/Prix Maitrisé') ||
            this.filters.taxes.includes('PINEL Sénior') ||
            this.filters.taxes.includes('PINEL Outre Mer') ||
            this.filters.taxes.includes('BRS') ||
            this.filters.taxes.includes('LLI') ||
            this.filters.brs
        );
    }

    isOnlyPinel() {
        return (
            this.filters.taxes.includes('Pinel / Rés. principale') ||
            this.filters.taxes.includes('RP Tva Réduite/Prix Maitrisé') ||
            this.filters.taxes.includes('PINEL Sénior') ||
            this.filters.taxes.includes('PINEL Outre Mer') ||
            this.filters.taxes.length == 0
        );
    }

    isAncienARehab() {
        return (
            this.filters.taxes.includes('PINEL Ancien') ||
            this.filters.taxes.includes('Denormandie') ||
            this.filters.taxes.includes('Malraux') ||
            this.filters.taxes.includes('Monuments historiques') ||
            this.filters.taxes.includes('Déficits fonciers') ||
            this.filters.taxes.includes('Projet construction') ||
            this.filters.taxes.includes('Loi COSSE Ancien-Louer Abordable')
        );
    }

    onScroll(event: any) {
        this.scrollTop = event.target.scrollTop;
    }

    isFamilySelected(taxe: string) {
        return this.familiesSelected.includes(taxe);
    }

    filterTaxes(taxe: string) {
        if (this.familiesSelected.includes(taxe)) {
            const index = this.familiesSelected.indexOf(taxe);
            this.familiesSelected.splice(index, 1);
            this.filters.taxes = [];
        } else {
            this.familiesSelected.push(taxe);
            this.taxSystems.forEach((element) => {
                if (element.family == taxe) {
                    this.filters.taxes.push(element.value);
                }
            });
        }
    }

    async check(key: string) {
        //@ts-ignore
        console.log(this.VEFA);
    }

    get isSubscribed() {
        return AuthModule.isSubscribed;
    }

    get fetchProgramsPrescriber() {
    console.log('fetchProgramsPrescriber');
    return fetchProgramsPrescriber;
}
    searchProgram = debounce(this.fetchProgramsPrescriber, 300);

    get fetchProgramOperatorPrescriber() {
        console.log('fetchProgramOperatorPrescriber')
        return fetchProgramOperatorPrescriber;
    }
    searchOperator = debounce(this.fetchProgramOperatorPrescriber, 300);

    get fetchPromotorsPrescriber() {
        console.log('fetchPromotorsPrescriber')
        return fetchPromotorsPrescriber;
    }



    handleDemembrementChange(isChecked: boolean) {
    // Show the Usufruit and Nue Pro controls if Démembrement is checked, hide otherwise
    this.showUsufruitControls = isChecked && this.filters.taxes.includes('Démembrement de propriété');
    this.showNueProControls = isChecked && this.filters.taxes.includes('Démembrement de propriété');
    }

    // Méthode pour Revente
    handleReventeChange() {
        const reventeTaxes = [
            "Revente LMNP",
            "Revente LMNP Tourisme",
            "Revente LMNP Étudiant",
            "Revente LMNP Sénior",
            "Revente LMNP Rés",
            "Revente LMNP EHPAD"
        ];

        this.showReventeControls = this.filters.taxes.some((tax: string) => reventeTaxes.includes(tax));
    }

    @Watch('filters.taxes', { deep: true })
    onTaxesChange() {
        // Démembrement
        const isDemembrementSelected = this.filters.taxes.includes('Démembrement de propriété');
        this.showUsufruitControls = isDemembrementSelected;
        this.showNueProControls = isDemembrementSelected;

        if (!isDemembrementSelected) {
            this.filters.includeUsufruitDuration = false;
            this.filters.includeNuePro = false;
            this.filters.dureeNueProInterval = [null, null];
        }

        // Revente
        const reventeTaxes = [
            "Revente LMNP",
            "Revente LMNP Tourisme",
            "Revente LMNP Étudiant",
            "Revente LMNP Sénior",
            "Revente LMNP Rés",
            "Revente LMNP EHPAD"
        ];

        this.showReventeControls = this.filters.taxes.some((tax: string) => reventeTaxes.includes(tax));

        if (!this.showReventeControls) {
            this.filters.includeBailDuration = false;
            this.filters.bailDurationInterval = [0, 20];
        }
    }


    @Watch('filters.nuePro')
    onNueProChange() {
        if (this.filters.includeNuePro) {
            this.filters.dureeNueProInterval = [
                this.filters.nuePro[0],
                this.filters.nuePro[1]
            ]; 
        } else {
            this.filters.dureeNueProInterval = [null, null];
        }
        FiltersModule.onFilters(this.filters);
    }

    @Watch('filters.bailDurationInterval')
    onBailDurationChange() {
        if (this.filters.includeBailDuration) {
            this.filters.baildurationInterval = [
                this.filters.bailDurationInterval[0],
                this.filters.bailDurationInterval[1]
            ]; 
        } else {
            this.filters.baildurationInterval = [null, null];
        }
        FiltersModule.onFilters(this.filters);
    }

    get showInnerShadow() {
        return this.scrollTop > 0;
    }
    reset(): void {
        // @ts-ignore
        this.$refs.city.clear();
        // @ts-ignore
        this.$refs.program.clear();
        // @ts-ignore
        this.$refs.promotor.clear();
        this.familiesSelected = [];
        this.showUsufruitControls = false;
        this.filters = {
            status: '',
            dateInterval: [0, 98],
            dateIntervalFinBail: [0, 80],
            includeNuePro: false,
            nuePro: [30, 90],
            dureeNueProInterval: [null, null],
            includeBailDuration: false,
            bailDurationInterval: [0, 20],
            budget: {
                min: null,
                max: null,
            },
            program: null,
            taxes: [],
            types: [],
            types2: [],
            exposures: [],
            outdoors: [],
            country: undefined,
            region: undefined,
            departement: undefined,
            city: undefined,
            isLivrable: false,
            isActable: false,
            timeStep: 5,
            pinelPlus: false,
            brs: false,
            timeStepFinBail: 1,
            dutyFreeFeeMin: 0,
            profitabilityProgramGtieInterval: [1, 15],
            profitabilityProgramGtieStep: 1,
            includeUsufruitDuration: false,
            usufruitDuration: [1, 30],
            dureeUsufruitInterval: {
            min: null,
            max: null
            },
            promotor: undefined,
            type_flux: null,
            zones: [],
            statusProgram: AuthModule.roles.includes('ROLE_MANAGER')
                ? ['to_control', 'data_processing', 'diffused']
                : ['diffused'],
            electronic_sign: null,
            commercials: null,
        };
        ListModule.setLotsSelected([]);
        /*
        remove customerIDFromLocalstorage
        */
        localStorage.removeItem('customerIDDenouncedFresh');
    }

    onFilterProgram(value: Program | undefined) {
        if (value) {
            if (value.status !== 'sold') {
                this.filters.program = value.id; // This works for filtering
            } else {
                this.programSold.program = value.name;
                this.programSold.popup = true;
            }
        } else {
            // Handle clearing the filter - this is what was missing!
            this.filters.program = null;
        }
    }

    onFilterPromotor(value: number | undefined) {
        this.filters.promotor = value;
    }

    timeFormatter(value: number) {
    value -= 40;
    const currentQuarter = moment().quarter();
    const quarterValue = value; // No division needed
    const date = moment().quarter(currentQuarter + quarterValue).startOf('quarter');
    const part = date.quarter();
    const year = date.year();
    return `${part}T.${year}`;
}

    timeFormatterFinBail(value: number) {
        var date = moment().startOf('quarter')
        const currentQuarter = moment().quarter();
        value = (value+currentQuarter-1)
        if(value !== 0){
            var quotient = Math.floor(value/4);
            var remainder = value % 4;
            date = moment().add(quotient, 'y').quarter(remainder).startOf('quarter');
        }
        const part = date.quarter();
        const year = date.year();
        return `${part}T.${year}`;
    }

    percentFormatter(value: number) {
        return value + '%';
    }

    surfaceFormatter(value: number) {
        return value;
    }

    get dangerBudget() {
        const { filters } = this;
        if (filters.dutyFreeFeeMin > 20) {
            return true;
        }
        return false;
    }

    get regions() {
        return regions;
    }

    get departements() {
        return departments;
    }

    villes: Ville[] = [];

    get taxSystems() {
        return taxSystems;
    }

    get typesArr() {
        return typesArr;
    }

    get pinelZone() {
        return Object.keys(this.zones).map((key) => ({
            text: (this.zones as any)[key],
            value: key,
        }));
    }

    get types2ArrChunks() {
        return chunk(types2Arr, 3);
    }

    get exposuresArr() {
    return exposuresArr;
  }

    get outdoorsArr() {
        return outdoorsArr;
    }

    get userFirstname() {
        return AuthModule.firstname;
    }

    get userLastname() {
        return AuthModule.lastname;
    }

    get logo() {
        return AuthModule.logo;
    }

    get backendUrl() {
        return BACKEND_URL;
    }

    filterOption(input: any, option: any) {
        return (
            option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
    }

    get privateMode() {
        return FiltersModule.privateMode;
    }

    togglePrivateMode() {
        this.isPrivateMode = !this.isPrivateMode;
        FiltersModule.togglePrivateMode();
    }

    async fetchCitiesPrescriber(input: string) {
        const { data } = await cities(input);
        this.cities = data;

        const transformed = data.map((el) => ({
            text: `${el.nom} (${el.departement.code})`,
            value: el.code,
        }));

        return transformed;
    }

    onFilterCity(value: string) {
        if (!value) {
            this.filters.city = undefined;
            return;
        }

        const city = this.cities.find((x) => x.code === value);

        if (city) {
            this.filters.city = city.nom;
            this.filters.departement = city.departement.code;


            MapModule.centerOnCity(city.nom);
        }
    }

    async getNbOfPrograms(taxSystem: string) {
        console.log(this.programs);
    }

    get programs() {
        return ListModule.programs;
    }

    get operators() {
    let meta = ListModule.meta;
    if(meta.operators) {

        return [...new Set(meta.operators)].filter(Boolean).sort();
    }
    return [];
}

    debugFilter() {
        console.log("Filter value changed:", this.filters.isLivrable);
        console.log("Full filters state:", this.filters);

        console.log('Current filters:', {
        country: this.filters.country,
        region: this.filters.region,
        departement: this.filters.departement,
        city: this.filters.city
    });



    }
            @Watch('filters.departement')
            public async onFiltersDepartement(newDept?: string) {
             // Si on efface le département, on clear la ville
            if (!newDept) {
            // @ts-ignore
            this.$refs.city.clear();
            this.filters.city = undefined;
            return;
            }

            // Si on sélectionne un département...
            const dept = departments.find(d => d.code === newDept);
            if (dept) {
            // 1) synchroniser la région parente
            this.filters.region = dept.region_code;

            // 2) attendre bien l’action Vuex
            console.log('[Sidebar] centering on department', newDept);
            await MapModule.centerOnDepartment(newDept);
            console.log('[Sidebar] action complete');
            }
        }

        @Watch('filters.region')
        public async onFiltersRegion(newRegion: string | undefined) {
            // Si on efface la région
            if (!newRegion) {
            this.filters.departement = undefined;
            return;
            }

            // Si on sélectionne une région, on recentre
            console.log('[Sidebar] centering on region', newRegion);
            await MapModule.centerOnRegion(newRegion);
            console.log('[Sidebar] action complete');
        }

    get ElectronicSignChoices() {
        const choices: any = [
            {
                text: 'Non determiné',
                value: 'nc',
            },
            {
                text: 'Signature éléctronique Vendeur',
                value: 'elec',
            },
            {
                text: 'Signature éléctronique Interne',
                value: 'elecInt',
            },
            {
                text: 'Signature Papier ou éléctronique Interne',
                value: 'paperOrElecInt',
            },
            {
                text: 'Signature Papier uniquement',
                value: 'paper',
            },
        ];
        return choices;
    }

    get commercialOffersChoices() {
        const choices: any = [
            {
                text: 'Tout',
                value: null,
            },
            {
                text: 'Boost Hono',
                value: true,
            },
            {
                text: 'Avant. Client',
                value: false,
            },
        ];
        return choices;
    }

    get programStatusArr() {
        const status = Object.keys(programStatus).map((key) => ({
            text: (programStatus as any)[key],
            value: key,
        }));

        const all = {
            text: 'Toutes',
            value: '',
        };

        return concat([all], status);
    }

    /**
     * number, dot and comma
     */
    isNumber(evt: KeyboardEvent) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (
            charCode > 31 &&
            (charCode < 48 || charCode > 57) &&
            charCode !== 46 &&
            charCode !== 44
        ) {
            evt.preventDefault();
        } else {
            return true;
        }
    }




    mounted(): void {
    document.addEventListener('click', (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest('.custom-vuesax-select')) {
   

        this.showTypes          = false;
        this.showRooms          = false;
        this.showOrientations   = false;
        this.showTypeMaj        = false;


      }
    });
  }




   // --- Dropdown state ---
   showTypes = false;
  showRooms = false;

  showOrientations: boolean = false;
  showTypeMaj: boolean = false;
  expandedFamilies: string[] = [];


  get typeMajArr() {
    return [
      { text: "Tous",        value: null },
      { text: "Manuels",     value: "man"  },
      { text: "Automatiques",value: "aut"  }
    ];
  }


  // --- Computed properties pour afficher le texte sélectionné ---
  get selectedTypesText(): string[] {
    return this.filters.types.map((value: string) => {
      const item = this.typesArr.find((t: any) => t.value === value);
      return item ? item.text : value;
    });
  }

  get selectedRoomsText(): string[] {
    // this.types2ArrChunks est un tableau de chunks, on le “flatten”
    const flatArr = this.types2ArrChunks.flat();
    return this.filters.types2.map((value: string) => {
      const item = flatArr.find((t: any) => t.value === value);
      return item ? item.text : value;
    });
  }

  // --- Méthodes pour ouvrir/fermer les dropdowns ---
  toggleTypes(): void {
    this.showTypes = !this.showTypes;
    if (this.showTypes) {
      this.showRooms = false;
    }
  }

  toggleRooms(): void {
    this.showRooms = !this.showRooms;
    if (this.showRooms) {
      this.showTypes = false;
    }
  }

  toggleTaxFamily(familyKey: string): void {
    const index = this.expandedFamilies.indexOf(familyKey);
    if (index > -1) {
        this.expandedFamilies.splice(index, 1);
    } else {
        this.expandedFamilies.push(familyKey);
    }
}


  // --- Méthodes pour cocher/décocher un item ---
  toggleType(value: string): void {
    const idx = this.filters.types.indexOf(value);
    if (idx > -1) {
      this.filters.types.splice(idx, 1);
    } else {
      this.filters.types.push(value);
    }
  }

  toggleRoom(value: string): void {
    const idx = this.filters.types2.indexOf(value);
    if (idx > -1) {
      this.filters.types2.splice(idx, 1);
    } else {
      this.filters.types2.push(value);
    }
  }

  // --- Méthodes pour supprimer depuis le “tag” affiché ---
  removeType(text: string): void {
    const item = this.typesArr.find((t: any) => t.text === text);
    if (!item) return;
    const idx = this.filters.types.indexOf(item.value);
    if (idx > -1) {
      this.filters.types.splice(idx, 1);
    }
  }

  removeRoom(text: string): void {
    const flatArr = this.types2ArrChunks.flat();
    const item = flatArr.find((t: any) => t.text === text);
    if (!item) return;
    const idx = this.filters.types2.indexOf(item.value);
    if (idx > -1) {
      this.filters.types2.splice(idx, 1);
    }
  }



  get selectedExposuresText(): string[] {
    return this.filters.exposures.map((value: string) => {
      const item = this.exposuresArr.find(e => e.value === value);
      return item ? item.text : value;
    });
  }

  get selectedTypeMajText(): string {
    const item = this.typeMajArr.find(t => t.value === this.filters.type_flux);
    return item ? item.text : "";
  }

  // … vos autres getters …

  // --- Méthodes pour vos nouveaux dropdowns ---
  toggleOrientations(): void {
    this.showOrientations = !this.showOrientations;
    if (this.showOrientations) {
      this.showTypeMaj = false;
    }
  }

  toggleTypeMaj(): void {
    this.showTypeMaj = !this.showTypeMaj;
    if (this.showTypeMaj) {
      this.showOrientations = false;
    }
  }

  toggleExposure(value: string): void {
    const idx = this.filters.exposures.indexOf(value);
    if (idx > -1) {
      this.filters.exposures.splice(idx, 1);
    } else {
      this.filters.exposures.push(value);
    }
  }

  selectTypeMaj(value: string | null): void {
    this.filters.type_flux = value;
    this.showTypeMaj = false;
  }

  removeExposure(text: string): void {
    const item = this.exposuresArr.find(e => e.text === text);
    if (!item) return;
    const idx = this.filters.exposures.indexOf(item.value);
    if (idx > -1) {
      this.filters.exposures.splice(idx, 1);
    }
  }

  



}
